import { Flex, Box } from "@chakra-ui/layout";
import { Image } from "@chakra-ui/react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import OutlineButton from "ui/components/Button/OutlineButton";
import Heading from "../heading";
import Stepper from "../stepper";
import ButtonPular from "../ButtonPular";

interface CardOnboardingProps {
  imageSrc: any;
  headingText: string;
  subheadText?: string;
  onNext: () => any;
  onBack?: () => any;
  onNextText?: string;
  onBackText?: string;
  onPular?: boolean;
  step: number;
}

function CardOnboarding({
  imageSrc,
  headingText,
  subheadText,
  onNext,
  onBack,
  onNextText = "CONTINUAR",
  onBackText = "VOLTAR",
  onPular = false,
  step,
}: CardOnboardingProps) {
  return (
    <Flex flexDir="column">
      <Flex>
        <Box
          width="978px"
          height="476px"
          style={{ backgroundColor: "#ffff", borderRadius: "16px" }}
        >
          <Flex height="100%">
            <Image src={imageSrc} margin="45px" marginTop="0px" width="40%" />
            <Flex flexDir="column" padding="45px">
              {onPular ? <ButtonPular /> : null}
              <Flex flexDir="column" marginTop="57px">
                <Heading headingText={headingText} subheadText={subheadText} />
              </Flex>
              <Flex
                align="flex-end"
                justifyContent="end"
                marginTop="auto"
                w="100%"
              >
                {onBack ? (
                  <OutlineButton
                    padding="19px"
                    height="40px"
                    color="#939393"
                    borderColor="#939393"
                    onClick={onBack}
                  >
                    {onBackText}
                  </OutlineButton>
                ) : null}
                <PrimaryButton
                  marginLeft="13px"
                  padding="20px"
                  height="40px"
                  onClick={onNext}
                >
                  {onNextText}
                </PrimaryButton>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </Flex>
      <Flex justifyContent="center" marginTop="30px">
        <Stepper stepAtivo={step} />
      </Flex>
    </Flex>
  );
}

export default CardOnboarding;
